/**
 * Created by mh on 2017/5/28.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import JobLogMessageModel from './model/JobLogMessageModel';

const TypeToColorClass = (type) => {
    switch (type) {
    case 'INFO':
        return 'badge-primary';
    case 'DEBUG':
        return 'badge-info';
    case 'WARNING':
        return 'badge-warning';
    case 'ERROR':
        return 'badge-danger';
    default:
        return 'badge-secondary';
    }
};

const TypeBadge = type => <span className={`badge ${TypeToColorClass(type)}`}>{type}</span>;

@observer
export default class LogsTableRow extends React.Component {
    render() {
        const { log } = this.props;
        return (
            <tr>
                <td className="align-middle">
                    {TypeBadge(log.level)}
                </td>
                <td className="align-middle" style={{ whiteSpace: 'nowrap' }}><code>{log.timestamp}</code></td>
                <td className="align-middle" style={{ whiteSpace: 'nowrap' }}><code>{log.loggername}</code></td>
                <td className="align-middle"><code>{log.message}</code></td>
            </tr>);
    }
}
LogsTableRow.propTypes = {
    log: PropTypes.instanceOf(JobLogMessageModel).isRequired,
};
